import React from 'react'
import { Button, Card, CardContent } from '@/shared/ui'
import { Checkbox } from '@/shared/ui/Checkbox'

type Props = {
  open: boolean
  html: string
  loading?: boolean
  error?: string | null
  onConfirm: () => void
}

export function OportunidadesNoticeModal({ open, html, loading, error, onConfirm }: Props) {
  const [checked, setChecked] = React.useState(false)

  React.useEffect(() => {
    if (!open) setChecked(false)
  }, [open])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black/60 backdrop-blur-md px-3 py-6 overflow-y-auto">
      <Card className="my-4 w-full max-w-2xl max-h-[80vh] overflow-y-auto border border-border/70 bg-white text-black">
        <CardContent className="flex flex-col gap-3 pt-4">
          <h2 className="text-lg font-semibold text-black">Aviso importante sobre Oportunidades</h2>
          {error && (
            <div className="rounded-md border border-destructive/30 bg-destructive/10 p-2 text-xs text-destructive-foreground">
              {error}
            </div>
          )}
          <div className="rounded-md bg-white p-3 text-sm text-black">
            {/* Conteúdo configurável vindo do RichTextEditor (HTML confiável do master) */}
            {html ? (
              <div dangerouslySetInnerHTML={{ __html: html }} />
            ) : (
              <p className="text-black/80">
                O módulo de Oportunidades exibe sinais automatizados com base em regras técnicas. Antes de utilizá-lo, confirme
                que leu e está ciente deste comunicado.
              </p>
            )}
          </div>
          <div className="mt-2 flex flex-col gap-2 border-t border-border/20 pt-3">
            <label className="inline-flex items-start gap-2 text-[11px] leading-snug text-black">
              <Checkbox checked={checked} onChange={(e) => setChecked(e.target.checked)} />
              <span>
                Li e estou plenamente de acordo com as regras. Estou ciente de que toda e qualquer decisão sobre participar ou não
                de uma oportunidade sugerida pelo Cripto Alert é de minha exclusiva responsabilidade, e que a plataforma não possui
                responsabilidade sobre lucros, perdas ou prejuízos que eu possa ter.
              </span>
            </label>
            <div className="flex items-center justify-end gap-2">
              <Button
                disabled={!checked || loading}
                onClick={() => {
                  if (!checked || loading) return
                  onConfirm()
                }}
              >
                {loading ? 'Registrando aceite...' : 'Estou ciente e desejo continuar'}
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
